export default "__VITE_PUBLIC_ASSET__b0543b66__"